// extracted by mini-css-extract-plugin
module.exports = {"base":"WaveEffect_base__MTgnC","wave":"WaveEffect_wave__IsWzX","appear":"WaveEffect_appear__doJF5","active":"WaveEffect_active__H6fCz"};